import useSEO from '../hooks/useSEO';
import { Box } from '@mui/material';

import HeroWaveform          from '../components/sections/HeroWaveform';
import VideoShowcaseSection  from '../components/sections/VideoShowcaseSection';
import VoiceCloningSection   from '../components/sections/VoiceCloningSection';
import LipSyncSection        from '../components/sections/LipSyncSection';
import TranslationSection    from '../components/sections/TranslationSection';
import MetricsParticles      from '../components/sections/MetricsParticles';
import TestimonialsFloat     from '../components/sections/TestimonialsFloat';
import GlobeSection3D        from '../components/sections/GlobeSection3D';
import CinematicCTA          from '../components/sections/CinematicCTA';

export default function HomePage() {
  useSEO({
    title: 'DubLabs — AI Video Dubbing in 32 Languages | Book Demo',
    description:
      'DubLabs clones your voice and dubs your videos into 32 languages with perfect lip-sync in under 4 minutes. Reach every global market — book a demo today.',
    keywords: 'AI video dubbing, voice cloning, lip sync, multilingual video, DubLabs',
    canonical: 'https://dublabs.ai',
    ogImage:   'https://dublabs.ai/og-image.png',
  });

  return (
    <Box sx={{ background: '#000' }}>
      {/* 01 — Hook: Your voice in every language */}
      <HeroWaveform />

      {/* 02 — Proof first: language switcher demo */}
      <VideoShowcaseSection />

      {/* 03 — How: Voice cloning explained */}
      <VoiceCloningSection />

      {/* 04 — How: Lip sync explained */}
      <LipSyncSection />

      {/* 05 — How: Translation orbital */}
      <TranslationSection />

      {/* 06 — Results: metrics */}
      <MetricsParticles />

      {/* 07 — Social proof */}
      <TestimonialsFloat />

      {/* 08 — Scale: global reach */}
      <GlobeSection3D />

      {/* 09 — CTA */}
      <CinematicCTA />
    </Box>
  );
}
